export const HomeListingCard = styled.section`
  .homeListingItem {
    ${({ theme: { isDesktop } }) =>
      isDesktop ? `width:220px;` : `flex-basis: 31.1%`};
  }
 
  .priceLabel {
    padding: 5px 8px;
    margin-top:${({ theme: { isDesktop, isRTL } }) =>isDesktop ? "-44px;" : "-34px;"}
    background: rgba(0, 0, 0, 0.7);
    max-width: 90%;
    ${({ theme: { isRTL } }) => (isRTL ? `left: 8px;` : `right: 8px;`)}
    .trim {
      max-width: 100%;
    }
  }

  ${({ theme: { isDesktop } }) => isDesktop && ".withNoImage a {width: 48%}"}
`;

import styled from "styled-components";
